module.exports = __webpack_public_path__ + "static/img/album-status-2.c811a238.png";